module.exports = __webpack_public_path__ + "static/media/HCMM842.e9fa624d.jpg";